import _extends from "@babel/runtime/helpers/esm/extends";
import { Tooltip } from "../Tooltip";
import { AnimatePresence, motion } from 'framer-motion';
import { eases } from "../../motion/eases";
import React from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
var TOOLTIP_OFFSET = [0, 10];
export function InputErrorAdornment(_ref) {
  var error = _ref.error,
      errorVariant = _ref.errorVariant;

  function renderContent() {
    var icon = /*#__PURE__*/React.createElement(AlertSVG, null);

    if (errorVariant === 'tooltip') {
      return /*#__PURE__*/React.createElement(Tooltip, {
        offset: TOOLTIP_OFFSET,
        delayIn: 50,
        placement: "top",
        title: error
      }, icon);
    }

    return icon;
  }

  return /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, error && /*#__PURE__*/React.createElement(StyledMotionBounce, null, renderContent()));
}
var AlertSVG = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledIconContainer, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.0566C11.6372 15.0566 14.6333 12.0542 14.6333 8.41699C14.6333 4.77979 11.6309 1.78369 8 1.78369C4.36279 1.78369 1.3667 4.77979 1.3667 8.41699C1.3667 12.0542 4.36279 15.0566 8 15.0566ZM8 13.5649C5.1499 13.5649 2.86475 11.2671 2.86475 8.41699C2.86475 5.56689 5.14355 3.27539 8 3.27539C10.8501 3.27539 13.1416 5.56689 13.1479 8.41699C13.1479 11.2671 10.8501 13.5649 8 13.5649ZM8 9.39453C8.37451 9.39453 8.59668 9.18506 8.61572 8.78516L8.71094 5.9541C8.72998 5.5415 8.42529 5.25586 7.99365 5.25586C7.55566 5.25586 7.25732 5.5415 7.27637 5.94775L7.37158 8.7915C7.38428 9.17871 7.60645 9.39453 8 9.39453ZM8 11.5337C8.43799 11.5337 8.79346 11.2354 8.79346 10.8037C8.79346 10.3784 8.44434 10.0801 8 10.0801C7.54932 10.0801 7.2002 10.3784 7.2002 10.8037C7.2002 11.2354 7.55566 11.5337 8 11.5337Z",
    fill: theme.colors.palette.alertError,
    fillOpacity: "0.8"
  })));
});
var StyledMotionBounce = styled(motion.div).attrs({
  initial: {
    scale: 0,
    opacity: 0
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      opacity: {
        duration: 0.2,
        ease: eases.primary
      },
      scale: {
        type: 'spring',
        stiffness: 281,
        damping: 22
      }
    }
  },
  exit: {
    opacity: 0,
    scale: 0,
    transition: {
      opacity: {
        duration: 0.2,
        ease: eases.primary
      },
      scale: {
        duration: 0.2,
        ease: eases.primary
      }
    }
  }
}).withConfig({
  displayName: "InputErrorAdornment__StyledMotionBounce",
  componentId: "vapor__sc-1wfi1f4-0"
})(["display:flex;align-items:center;align-self:stretch;transform-origin:", ";"], theme.spaces[8]);
var StyledIconContainer = styled.div.withConfig({
  displayName: "InputErrorAdornment__StyledIconContainer",
  componentId: "vapor__sc-1wfi1f4-1"
})(["display:flex;flex:1;align-items:center;align-self:stretch;width:", ";margin-right:", ";justify-content:center;position:relative;&:before{content:'';position:absolute;left:-", ";right:-", ";top:0;bottom:0;}"], theme.spaces[16], theme.spaces[8], theme.spaces[4], theme.spaces[4]);